module.exports = __webpack_public_path__ + "img/14.1f6e266a.jpg";